export default "__VITE_ASSET__B70JrZ87__"